import { useState, useEffect } from 'react'
import Card from '../components/Card'

const units = {
  ml: { name: 'Milliliter', factor: 0.001 },
  l: { name: 'Liter', factor: 1 },
  'm³': { name: 'Cubic Meter', factor: 1000 },
  'cm³': { name: 'Cubic Centimeter', factor: 0.001 },
  'in³': { name: 'Cubic Inch', factor: 0.0163871 },
  'ft³': { name: 'Cubic Foot', factor: 28.3168 },
  'yd³': { name: 'Cubic Yard', factor: 764.555 },
  cup: { name: 'Cup (US)', factor: 0.236588 },
  pint: { name: 'Pint (US)', factor: 0.473176 },
  quart: { name: 'Quart (US)', factor: 0.946353 },
  gallon: { name: 'Gallon (US)', factor: 3.78541 },
  'fl oz': { name: 'Fluid Ounce (US)', factor: 0.0295735 },
  tbsp: { name: 'Tablespoon (US)', factor: 0.0147868 },
  tsp: { name: 'Teaspoon (US)', factor: 0.00492892 },
}

export default function VolumeConverter() {
  const [fromUnit, setFromUnit] = useState('l')
  const [toUnit, setToUnit] = useState('ml')
  const [fromValue, setFromValue] = useState('')
  const [toValue, setToValue] = useState('')

  const convert = () => {
    if (!fromValue || isNaN(fromValue)) {
      setToValue('')
      return
    }

    const value = parseFloat(fromValue)
    const fromFactor = units[fromUnit].factor
    const toFactor = units[toUnit].factor

    const liters = value * fromFactor
    const result = liters / toFactor

    setToValue(result.toFixed(6).replace(/\.?0+$/, ''))
  }

  useEffect(() => {
    convert()
  }, [fromUnit, toUnit, fromValue])

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="label">From:</label>
              <select
                value={fromUnit}
                onChange={(e) => setFromUnit(e.target.value)}
                className="input w-full"
              >
                {Object.entries(units).map(([key, unit]) => (
                  <option key={key} value={key}>{unit.name}</option>
                ))}
              </select>
              <input
                type="number"
                value={fromValue}
                onChange={(e) => setFromValue(e.target.value)}
                className="input w-full mt-3"
                placeholder="Enter value"
                step="any"
              />
            </div>
            <div>
              <label className="label">To:</label>
              <select
                value={toUnit}
                onChange={(e) => setToUnit(e.target.value)}
                className="input w-full"
              >
                {Object.entries(units).map(([key, unit]) => (
                  <option key={key} value={key}>{unit.name}</option>
                ))}
              </select>
              <input
                type="text"
                value={toValue}
                readOnly
                className="input w-full mt-3 bg-gray-50"
                placeholder="Result"
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

